/* libs */
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";

/* components */
import Page from "../../shared/Page";
import GridFormSwitcher from "../../shared/GridFormSwitcher";
import Grid from "../../shared/Grid";
import PageFormWrapper from "./PageFormWrapper";
import AccessDenied from "../../main/AccessDenied";

/* helpers */
import * as controlPanelActions from "../../../actions/controlPanelActions";
import * as globalActions from "../../../actions/globalActions";
import * as integrationActions from "../../../actions/integrationActions";
import * as modulesActions from "../../../actions/modulesActions";
import * as pagesActions from "../../../actions/pagesActions";
import UserHasPermission from "../../../helpers/validation/userHasPermission";

class PagesPage extends Component {
	constructor(props) {
		super(props);
		this.expId = props.match.params.expId;
		this.appId = "";
		this.appKey = this.props.match.params.appKey;
		if (this.props.apps) {
			let app = this.props.apps.find(app => {
				return app.key === this.appKey;
			});
			this.appId = app ? app.id : "";
		}
		this.state = {
			hasFormApi: false,
			formApi: null,
		};
	}

	componentDidMount() {
		const { actions, integrationActions, modulesActions } = this.props;
		actions.loadPages(this.expId);
		modulesActions.loadModules();
		integrationActions.loadIntegrations(this.appKey);
	}

	getFormApi = formApi => {
		this.setState({ formApi, hasFormApi: true });
	};

	clearFormApi = () => {
		this.setState({ formApi: null, hasFormApi: false });
	};

	reloadPages = () => {
		const { actions, history } = this.props;
		actions.loadPages(this.expId);
		history.push(`/apps/${this.appKey}/experiences/${this.expId}/pages`);
	};

	logError = error => {
		console.log(error);
		/*error.response.data.Errors.forEach((error) => {
			this.state.formApi.setError(error.Key, error.Value);
		});*/
	};

	createItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const data = {
			...values,
			experienceId: this.expId,
		};
		globalActions.createItem(data, "/pages", this.reloadPages, this.logError, submitHandler);
	};

	updateItem = (values, submitHandler, itemId) => {
		const { globalActions } = this.props;
		globalActions.updateItem(values, `/pages/${itemId}`, this.reloadPages, this.logError, submitHandler);
	};

	copyItem = (values, submitHandler) => {
		const { globalActions } = this.props;
		const data = {
			...values,
			experienceId: values.experienceId ? values.experienceId : this.expId,
		};
		globalActions.createItem(data, "/pages", this.reloadPages, this.logError, submitHandler);
	};

	deleteItem = (id, name) => {
		let expId = this.expId;
		const { actions, globalActions } = this.props;
		const onSuccess = () => {
			actions.loadPages(expId);
		};
		globalActions.deleteItem(`/pages/${id}`, onSuccess, this.logError, name);
	};

	loadPage = pageId => {
		const { actions } = this.props;
		actions.loadPage(pageId);
	};

	showLoading = () => {
		this.props.controlPanelActions.showLoading();
	};

	hideLoading = () => {
		this.props.controlPanelActions.hideLoading();
	};

	filterModules = (modules, pages, integrations) => {
		const shownModules = [];

		modules.forEach(module => {
			if (isEmpty(module.requiredModules)) {
				shownModules.push(module);
			} else {
				const { requiredModules } = module;
				const hasAllRequiredModules = requiredModules.every(requiredModuleKey => {
					const hasIntegrationFromKey = integrations.some(i => i.moduleKey === requiredModuleKey);
					const hasPageFromKey = pages.some(p => p.moduleKey === requiredModuleKey);

					return hasIntegrationFromKey || hasPageFromKey;
				});

				if (hasAllRequiredModules) {
					shownModules.push(module);
				}
			}
		});

		return shownModules;
	};

	/* populate grid */

	renderGrid = () => {
		const { pages } = this.props.pages;

		return (
			<div>
				{pages ? (
					<Grid
						defaultText="There are currently no pages. Create your first page..."
						pluralItemName="pages"
						items={pages}
						delete={this.deleteItem}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</div>
		);
	};

	render() {
		const { auth, integrations, modules, pages, user } = this.props;
		let renderCopy = AccessDenied;
		let renderNew = AccessDenied;
		if (user && UserHasPermission(user, "structure")) {
			renderCopy = PageFormWrapper;
			renderNew = PageFormWrapper;
		}

		let filteredModules = modules;
		const haveModulesPagesAndIntegrations = modules && pages && integrations && !isEmpty(modules.modules);
		const showGridFormSwitcher = pages && haveModulesPagesAndIntegrations;

		if (haveModulesPagesAndIntegrations) {
			filteredModules = {
				modules: this.filterModules(modules.modules, pages.pages, integrations.integrations),
			};
		}

		return (
			<Page title="Pages">
				{showGridFormSwitcher ? (
					<GridFormSwitcher
						objectKey="Pages"
						singleItemName="Page"
						pluralItemName="Pages"
						RenderCopy={renderCopy}
						RenderEdit={PageFormWrapper}
						RenderNew={renderNew}
						items={pages.pages}
						renderGrid={this.renderGrid}
						createItem={this.createItem}
						updateItem={this.updateItem}
						copyItem={this.copyItem}
						modules={filteredModules}
						getSingleItem={this.loadPage}
						getFormApi={this.getFormApi}
						formApi={this.state.formApi}
						hasFormApi={this.state.hasFormApi}
						appKey={this.appKey}
						apps={this.props.apps}
						showLoading={this.showLoading}
						hideLoading={this.hideLoading}
						clearFormApi={this.clearFormApi}
						auth={auth}
					/>
				) : (
					<h1>Loading...</h1>
				)}
			</Page>
		);
	}
}

const mapStateToProps = state => ({
	apps: state.apps.apps,
	auth: state.auth,
	integrations: state.integrations,
	modules: state.modules,
	pages: state.pages,
	user: state.user.user,
});

const mapDispatchToProps = dispatch => ({
	actions: bindActionCreators(pagesActions, dispatch),
	controlPanelActions: bindActionCreators(controlPanelActions, dispatch),
	globalActions: bindActionCreators(globalActions, dispatch),
	integrationActions: bindActionCreators(integrationActions, dispatch),
	modulesActions: bindActionCreators(modulesActions, dispatch),
});

PagesPage.propTypes = {
	pages: PropTypes.object,
	actions: PropTypes.object,
	history: PropTypes.object,
	match: PropTypes.object,
	modulesActions: PropTypes.object,
	globalActions: PropTypes.object,
	apps: PropTypes.array,
	modules: PropTypes.object,
	controlPanelActions: PropTypes.object,
	user: PropTypes.object,
	auth: PropTypes.object,
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PagesPage);
